import 'jquery-match-height';

export default () => {
    $(document).ready(function() {
        $(function() {
            $('.gl-footer-widget, .gl-same-height').matchHeight();
        });
    });
};


/** WEBPACK FOOTER **
 ** ./assets/src/js/match_height/equalHeight.js
 **/